import { Link } from "react-router-dom";
import { BlogPost } from "../types";
import { PostImage1, PostImage2, PostImage3 } from "../images";
import { Col, Container, Row } from "react-bootstrap";

const Blog = () => {
    const posts: BlogPost[] = [
      {
        id: 1,
        title: 'Raw materials are locally sourced.',
        excerpt: 'Our team are a dedicated individuals who thrive to bring quality taste into our sauces',
        image: PostImage1,
        category: 'Locally Sourced Products',
        date: 'Jul 11, 2022'
      },
      {
        id: 2,
        title: 'Our Tomatoes Sauce brand is evolving.',
        excerpt: 'Outstanding tomatoes green housing.',
        image: PostImage2,
        category: 'Tomato Paste',
        date: 'Mar 20, 2023'
      },
      {
        id: 3,
        title: 'Absolutely fresh and amazing tomatoes sauce.',
        excerpt: 'Turpis purus, gravida orci, fringilla dignissim lacus, turpis ut suspendisse vel tellus...',
        image: PostImage3,
        category: 'Freash Products',
        date: 'Feb 17, 2024'
      },
    ];
  
    return (
      <section className="blog py-5">
        <Container>
          <div className="d-flex flex-wrap justify-content-between align-items-center mt-5 mb-3">
            <h4 className="text-uppercase">Read Blog Posts</h4>
            <Link to="#" className="btn-link">View All</Link>
          </div>
          <Row>
            {posts.map(post => (
              <Col key={post.id} md={4}>
                <article className="post-item">
                  <div className="post-image">
                    <Link to="#">
                      <img src={post.image} alt={post.title} className="post-grid-image img-fluid" />
                    </Link>
                  </div>
                  <div className="post-content d-flex flex-wrap gap-2 my-3">
                    <div className="post-meta text-uppercase fs-6 text-secondary">
                      <span className="post-category">{post.category} /</span>
                      <span className="meta-day"> {post.date}</span>
                    </div>
                    <h5 className="post-title text-uppercase">
                      <Link to="#">{post.title}</Link>
                    </h5>
                    <p>{post.excerpt}</p>
                  </div>
                </article>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    );
};
  
export default Blog;